import React, { useState, useEffect } from "react";
import Header from "../layouts/Header";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;
const API_FILE = process.env.REACT_APP_FILE_URL || "";

export default function HistoryPage() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<any[]>([]);
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const res = await fetch(`${API_URL}/history`, {
                method: "GET",
                credentials: "include",
            });
            if (!res.ok) throw new Error(`Error ${res.status}`);
            const result = await res.json();
            console.log(result)
            if (result.success && Array.isArray(result.url)) {
                setData(result.url);
            } else {
                setData([]);
            }
        } catch (err) {
            console.error("API error:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleCopy = async (encryptedId: string) => {
        if (!encryptedId) return;

        try {
            const encodedId = encodeURIComponent(encryptedId);
            const copyUrl = `${window.location.origin}/detail/${encodedId}`;

            await navigator.clipboard.writeText(copyUrl);

            Swal.fire({
                icon: "success",
                title: "Đã copy!",
                text: "Link chi tiết đã được copy vào clipboard.",
                showConfirmButton: false,
                timer: 2000,
            });
        } catch (error) {
            console.error("Lỗi khi copy URL:", error);
            Swal.fire({
                icon: "error",
                title: "Lỗi!",
                text: "Không thể copy link. Vui lòng thử lại.",
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };

    const handleEditTitle = (index: number) => {
        Swal.fire({
            title: "Nhập tiêu đề mới",
            input: "text",
            inputLabel: "Tiêu đề",
            inputValue: data[index].urls,
            showCancelButton: true,
            confirmButtonText: "Lưu",
        }).then(async (res) => {
            if (res.isConfirmed && res.value) {
                try {
                    const newTitle = res.value;
                    const itemId = data[index].id;

                    const response = await fetch(`${API_URL}/history-update/${itemId}`, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ urls: newTitle }),
                    });

                    const result = await response.json();
                    if (result.success) {
                        const newData = [...data];
                        newData[index].urls = newTitle;
                        setData(newData);

                        Swal.fire({
                            icon: "success",
                            title: "Đã lưu!",
                            text: "Tiêu đề đã được cập nhật thành công.",
                            timer: 1500,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Lỗi!",
                            text: result.message || "Không thể cập nhật tiêu đề.",
                        });
                    }
                } catch (error) {
                    console.error("Update error:", error);
                    Swal.fire({
                        icon: "error",
                        title: "Lỗi kết nối!",
                        text: "Không thể kết nối đến máy chủ.",
                    });
                }
            }
        });
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) return <div className="text-center py-10">Đang tải...</div>;

    return (
        <>
            <Header />
            <section className="sec-history mt-40">
                <div className="container">
                    <h1 className="text-center text-2xl font-bold mb-6 text-4xl font-bold">Danh sách</h1>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10">
                        {data.length > 0 ? (
                            data.map((item, index) => {
                                const firstImage = item.uploaded_images?.[0]?.image_path
                                    ? `${API_FILE}/${item.uploaded_images[0].image_path}`
                                    : `${process.env.PUBLIC_URL}/images/no-image.png`;

                                return (
                                    <div
                                        key={item.id}
                                        className="bg-white shadow-md rounded-xl overflow-hidden flex flex-col items-center pb-8"
                                    >
                                        <img
                                            src={firstImage}
                                            alt="preview"
                                            className="w-full h-48 object-cover rounded-md"
                                        />
                                        <div
                                            className="flex gap-3 mt-4 cursor-pointer group"
                                            onClick={() => handleEditTitle(index)}
                                        >
                                            <p className="mt-3 text-gray-800 font-semibold break-all group-hover:text-green-600 transition-colors duration-200 text-4xl">
                                                {item.urls}
                                            </p>
                                        </div>

                                        <div className="flex gap-3 mt-6">
                                            <Link
                                                to={`/edit/${item.encrypted_id}`}
                                                className="px-3 py-1 bg-yellow-400 hover:bg-yellow-500 text-white rounded-lg text-2xl inline-block text-center"
                                            >
                                                Chỉnh sửa
                                            </Link>

                                            <button
                                                onClick={() => handleCopy(item.encrypted_id)}
                                                className="px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded-lg text-2xl"
                                            >
                                                Chia sẻ
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <p className="text-center col-span-3 text-gray-500">
                                Không có dữ liệu.
                            </p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}
